// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2ogGX","file":"styles_file__y6G1b"};